import * as React from "react";
import { Dialog, Button, PrimaryButton } from "office-ui-fabric-react";
import { Template } from "typings";
import TemplateDropdown from "./TemplateDropdown";

export interface Props
{
    onCancel: () => void;
    templates: Template[];
    onTemplateSelected: (templateId: string) => void;
}

interface State
{
    
}

class TemplateSelectorDialog extends React.Component<Props, State>
{
    private templateId: string ="";
    onTemplateChange = (template: Template) =>
    {
        this.templateId =  template.id;
    }

    onCreate = () =>
    {
        this.props.onTemplateSelected(this.templateId);
    }

    render()
    {
        return (
            <Dialog hidden={false} onDismiss={this.props.onCancel} >
                <TemplateDropdown
                    onTemplateChange={this.onTemplateChange}
                    templates={this.props.templates}
                />
                <Button onClick={this.props.onCancel}>Cancel</Button>
                <PrimaryButton onClick={this.onCreate}>Ok</PrimaryButton>
            </Dialog>
        );
    }
}

export default TemplateSelectorDialog;


// WEBPACK FOOTER //
// ./src/components/product/TemplateSelectorDialog.tsx